import React from 'react';
import { Box, IconButton, Stack } from '@mui/material';
import styled from '@emotion/styled';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { FilterLayoutsFilter } from '@/redux/slices/slice_types';

interface Props {
  item: FilterLayoutsFilter;
  togglePin?: (columnName: 'show' | 'hide', id: string) => void;
}

const FilterLayoutItem: React.FC<Props> = ({ item: { id, label, is_quick, is_hidden }, togglePin }) => {
  const onPinIconButtonClick = () => {
    if (!togglePin) return;

    togglePin(is_hidden ? 'hide' : 'show', id);
  };

  return (
    <Wrapper direction="row" alignItems="center" gap={1.5}>
      {!is_hidden && (
        <PinIconButton className={`pin-icon-button${is_quick ? ' pin-icon-button_pinned' : ''}`} isPinned={is_quick} onClick={onPinIconButtonClick}>
          <PolarisIcon icon={is_quick ? 'pin' : 'pin_off'} width={14} />
        </PinIconButton>
      )}
      <Label className="filter-layout-item-label">{label}</Label>
      <GripIcon icon="grip" width={24} />
    </Wrapper>
  );
};

export default FilterLayoutItem;

const Wrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1, 1.5),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius * 1.2 + 'px'
}));

const PinIconButton = styled(IconButton, { shouldForwardProp: (prop) => !['isPinned'].includes(prop) })<{ isPinned: boolean }>(
  ({ theme, isPinned }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    width: 24,
    height: 24,
    color: isPinned ? theme.palette.primary.main : theme.palette.mode === 'dark' ? theme.palette.default.main : theme.palette.default.dark,
    background: isPinned ? theme.palette.primary.main + '3a' : undefined,
    '& svg': {
      height: 14,
      width: 14
    },
    '&:hover': {
      background: isPinned ? theme.palette.primary.main + '2a' : undefined
    }
  })
);

const Label = styled(Box)(() => ({
  flexGrow: 1,
  fontWeight: 700
}));

const GripIcon = styled(PolarisIcon)`
  color: ${({ theme }) => theme.palette.default.main};
`;
